













import { Component, Mixins, Watch } from "vue-property-decorator";
import { IItem } from "../../../../../../domain/document/items";
import { instanceOfIWizardObjectDecoratable, IWizardInputDecoratable } from "../../../../../../domain/format";
import { DateFormatter } from "../../../../../../domain/system";
import { FatalIndicator, QuotedBadge } from "./common";
import { ObjectReferableContentMixin } from "./mixins";
import { DateValueAccessor } from "./accessors";

@Component({
  components: {
    FatalIndicator,
    QuotedBadge,
  }
})
export default class WizardContentDateInput extends Mixins(ObjectReferableContentMixin) {
  data() {
    return {
      accessor: null as DateValueAccessor,
      error: "",
    };
  }
  accessor: DateValueAccessor;
  error: string;

  get text(): string {
    if (!this.accessor) {
      return "";
    }
    const value = this.accessor.get();
    return value
      ? DateFormatter.format(value, "YYYY-MM-DD")
      : "";
  }

  set text(value: string) {
    const converted = value
      ? new Date(value)
      : null;
    this.updateItem(this.accessor.set(converted));
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  initialize(newValue: IItem) {
    try {
      this.accessor = new DateValueAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }
  
  get prefix(): string {
    return this.readDecoration(s => s.prefix);
  }

  get postfix(): string {
    return this.readDecoration(s => s.postfix);
  }

  private readDecoration(read: (s: IWizardInputDecoratable) => string): string {
    return (instanceOfIWizardObjectDecoratable(this.content) && !!read(this.content.decoration))
      ? read(this.content.decoration)
      : "";
  }
}
